import moment from 'moment-timezone';
import {SynchronousPromise} from 'synchronous-promise';
import {fakeUser} from '../authentication/FakeAuthenticationService';
import {aUser} from '../../utils/fixtures';
import {MANAGER_ROLE, INVITING_ROLE, SIGN_PERMISSION} from '../../utils/constant';

const usersInDb = [
  {
    id: 'some-uuid',
    firstName: 'logged',
    lastName: 'user',
    fullName: 'logged user',
    email: 'logged.user@onceforall.com',
    language: 'en',
    phoneNumber: '+33123456789',
    organisationId: 1,
    createdDate: '2018-03-28T15:00:24.799Z',
    enabled: true,
    isBackOffice: false,
    organisationRole: MANAGER_ROLE,
    roleByOrganisationIds: {
      1: MANAGER_ROLE
    },
    permissionsByOrganisationIds: null,
    deactivatedDate: null,
    options: []
  },
  {
    id: '2dff3852-ee1c-40d5-a2d0-b5d7d5619169',
    firstName: 'firstName',
    lastName: 'lastName',
    fullName: 'firstName lastName',
    email: 'firstName.lastName@onceforall.com',
    language: 'en',
    phoneNumber: '+33123456789',
    organisationId: 1,
    createdDate: '2018-03-28T15:00:24.799Z',
    enabled: true,
    isBackOffice: false,
    organisationRole: MANAGER_ROLE,
    roleByOrganisationIds: {
      1: MANAGER_ROLE
    },
    permissionsByOrganisationIds: {
      1: [SIGN_PERMISSION]
    },
    deactivatedDate: null,
    options: []
  },
  {
    id: '9231a32d-1163-444d-8587-e2680ee4a3ab',
    firstName: 'Bruce',
    lastName: 'Wayne',
    fullName: 'Bruce Wayne',
    email: 'bruce.wayne@waynecorporation.com',
    language: 'en',
    phoneNumber: '+33123456790',
    organisationId: null,
    createdDate: '2018-03-26T15:00:24.799Z',
    enabled: true,
    isBackOffice: true,
    organisationRole: MANAGER_ROLE,
    roleByOrganisationIds: null,
    permissionsByOrganisationIds: null,
    deactivatedDate: null,
    options: []
  },
  {
    id: '9231a32d-1163-444d-8587-e2680ee4a3cd',
    firstName: 'Joker',
    lastName: '',
    fullName: 'Joker',
    email: 'joker@chaos.com',
    language: 'en',
    phoneNumber: '+33123456791',
    organisationId: 3,
    createdDate: '2018-03-26T15:00:24.799Z',
    enabled: true,
    isBackOffice: false,
    organisationRole: INVITING_ROLE,
    roleByOrganisationIds: {
      3: INVITING_ROLE
    },
    permissionsByOrganisationIds: null,
    deactivatedDate: null,
    options: []
  },
  {
    id: '9231a32d-1163-444d-8587-e2680ee4a3ce',
    firstName: 'Red',
    lastName: 'Robin',
    fullName: 'Red Robin',
    email: 'red.robin@waynecorporation.com',
    language: 'en',
    phoneNumber: '+33123456792',
    organisationId: 2,
    createdDate: '2018-03-26T15:00:24.799Z',
    enabled: true,
    isBackOffice: false,
    organisationRole: MANAGER_ROLE,
    roleByOrganisationIds: {
      2: MANAGER_ROLE
    },
    permissionsByOrganisationIds: {
      1: [SIGN_PERMISSION]
    },
    deactivatedDate: null,
    options: []
  },
  {
    id: '9231a32d-1163-444d-8587-e2680ee4a3fd',
    firstName: 'Thomas',
    lastName: 'Wayne',
    fullName: 'Thomas Wayne',
    email: 'thomas.wayne@waynecorporation.com',
    language: 'en',
    phoneNumber: '+33123456790',
    organisationId: 2,
    createdDate: '2018-03-26T15:00:24.799Z',
    enabled: true,
    isBackOffice: false,
    organisationRole: INVITING_ROLE,
    roleByOrganisationIds: {
      2: INVITING_ROLE
    },
    permissionsByOrganisationIds: null,
    deactivatedDate: null,
    options: []
  },
  {
    id: '9231a32d-1163-444d-8587-e2680ee4a3ff',
    firstName: 'Deactivated',
    lastName: 'User',
    fullName: 'Deactivated User',
    email: 'deactivated.user@deactivated.com',
    language: 'en',
    phoneNumber: '+33123456791',
    organisationId: 1,
    createdDate: '2018-03-26T15:00:24.799Z',
    enabled: false,
    isBackOffice: false,
    organisationRole: INVITING_ROLE,
    roleByOrganisationIds: {
      1: INVITING_ROLE
    },
    permissionsByOrganisationIds: null,
    deactivatedDate: `${moment().get('years')}-03-26T15:00:24.799Z`,
    options: []
  }
];

export default class FakeUserService {
  searchByOrganisation(organisationId, query = '', page = 0, size = 10) {
    const users = usersInDb
      .filter(user => user.organisationId === organisationId)
      .filter(user => user.fullName.toLowerCase().startsWith(query));
    return Promise.resolve({
      users: users.slice(page * size, (page + 1) * size),
      totalCount: users.length
    });
  }

  publicSearchByOrganisation(organisationId, query = '', page = 0, size = 10) {
    const users = usersInDb
      .filter(user => user.organisationId === organisationId)
      .filter(user => user.fullName.toLowerCase().startsWith(query));
    return Promise.resolve({
      users: users.slice(page * size, (page + 1) * size),
      totalCount: users.length
    });
  }

  searchByEmail(email) {
    const user = usersInDb.filter(userItem => userItem.email === email);
    if (user.length > 0) {
      return SynchronousPromise.resolve({
        status: 200,
        json: (() => SynchronousPromise.resolve(user[0]))
      });
    }

    return Promise.resolve({status: 204});
  }

  getUserDetailsById(userId) {
    if (userId === fakeUser.id) {
      return Promise.resolve(aUser(fakeUser));
    }

    const user = usersInDb.find(userItem => userItem.id === userId);
    return user ? Promise.resolve(user) : Promise.reject();
  }

  createUser(user) {
    return Promise.resolve(user);
  }

  linkOrganisationOnRegister(organisationId, userId) {
    return Promise.resolve({
      organisationId,
      userId
    });
  }

  linkOrganisationToUsers() {
    return Promise.resolve();
  }

  linkOrganisationToNewUsers() {
    return Promise.resolve();
  }

  unlinkUserFromOrganisation() {
    return Promise.resolve();
  }

  sendActivationEmail() {
    return Promise.resolve();
  }

  updateLanguage() {
    return Promise.resolve();
  }

  updateUserDetails(userDetails) {
    const index = usersInDb.findIndex(user => user.id === userDetails.id);
    if (index < 0) {
      return Promise.reject();
    }

    const clone = {...userDetails};
    clone.fullName = `${clone.firstName} ${clone.lastName}`;
    usersInDb[index] = clone;
    return Promise.resolve();
  }

  updateOptions() {
    return Promise.resolve();
  }

  requestUpdateEmail() {
    // NOOP has, the email is not changed until the user validate his new email address
    return Promise.resolve();
  }

  updateEmail() {
    return Promise.resolve();
  }

  getGeneralTermsLastMajorVersionUpdateTimestamp() {
    // A very useful comment for Mister Zebille to say that this timestamp is equivalent to 26 of August 2019 at 15:48:22
    return Promise.resolve(1566834502);
  }

  acceptLegalConditions() {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, 0);
    });
  }

  getPrivacyPolicyLastMajorVersionUpdateTimestamp() {
    // A very useful comment for Mister Zebille to say that this timestamp is equivalent to 26 of August 2019 at 15:48:22
    return Promise.resolve(1566834502);
  }

  getAcceptationDomainNameAutomaticTieUser() {
    return Promise.resolve([
      {
        id: 1,
        registrationNumber: '11234567458765',
        domainName: 'mail.com',
        groupIdentifier: '123456789'
      },
      {
        id: 2,
        registrationNumber: '11234567458765',
        domainName: 'onceforall.com',
        groupIdentifier: '123456789'
      }
    ]);
  }

  createInvitationByUser() {
    return Promise.resolve({status: 204});
  }

  doesUserExistsInArtio() {
    return Promise.resolve(true);
  }
}
